module.exports = __webpack_public_path__ + "img/sosTitBg2.45c35db2.png";